import { axios as $http } from 'cm'
import { getRunTime } from '../../../public-resource/libs/utils'
import GetQueryString from '../../../public-resource/get-query'
import { getRequestSign } from '../../../frontend-lib/tools/platformSign'
import { getRunningEnv } from 'src/frontend-lib/tools/getPlatform'

const m_host = location.protocol + getRunTime('//m.xinli001.com')

export function getWechatAuth() {
  const code = GetQueryString('code')
  return $http(`${m_host}/common/get-wx-auth.json`, {
    params: {
      name: getRunningEnv().isDev ? 'yida' : 'yixinlicia',
      code: code || '',
      redirect_url:
        location.origin +
        location.pathname +
        location.search.replace(/[?&]code=([^?&]+)/, ''),
      auth_type: 'manual'
    }
  }).then(({ data }) => {
    if (data.code === 302) {
      window.location.href = data.data.redirect_url
    } else if (data.code === 0) {
      return Promise.resolve(wechatLogin(data.data))
    }
  })
}

export function wechatLogin(data) {
  let params = {
    flag: 'weixin-fw',
    union_id: data.union_id,
    open_id: data.open_id,
    redirect_uri: location.href,
    oauth_from: 'weixin-fw',
    scenario: 'access',
    _version: '6.6.0', // App版本号
    _platform: 'wechat' // 平台，ios或android 默认值: ios
  }
  let platFormSign = getRequestSign(params, '60af3c99ecf6a22b70143f5291570d4b')
  let newParams = Object.assign(platFormSign.params, {
    sign: platFormSign.sign
  })
  newParams.redirect_uri = encodeURIComponent(location.href)

  let paramsUrl = JSON.stringify(newParams)
    .replace(/[\"\{\}]/g, '')
    .replace(/\:/g, '=')
    .replace(/\,/g, '&')
  let ACCOUNT_HOST = getRunTime('https://account.xinli001.com')
  let wechatLogin = `${ACCOUNT_HOST}/oauth/wechat-login`
  console.log('wechatLogin', `${wechatLogin}?${paramsUrl}`)
  window.location.replace(`${wechatLogin}?${paramsUrl}`)
}



// WEBPACK FOOTER //
// ./src/pages/promotion/template/wechatAuth.js